import { Link } from "react-router-dom";
import { ArrowRight, Sparkle, Tag } from "@phosphor-icons/react";
import {
  MATERIALS,
  MATERIAL_LINK,
  QUICK_LINKS,
  REMNANT_LINK,
  VIEWS,
} from "@/lib/siteMenu";

const QUICK_ICONS = { new: Sparkle, sale: Tag };

// Full-width menu under the header: materials, quick picks and the remnants shout-out.
export const InventoryMega = ({ onPick }) => (
  <div
    data-testid="site-nav-inventory-menu"
    className="absolute inset-x-0 top-full hidden border-t border-white/10 bg-[color:var(--s-dark)] text-white shadow-[0_40px_80px_-40px_rgba(0,0,0,0.7)] lg:block"
  >
    <div className="grid gap-12 px-6 py-12 lg:grid-cols-[1.6fr_0.8fr_1fr] lg:px-12">
      <div>
        <div className="s-micro text-[color:var(--s-gold-bright)]">By material</div>
        <div className="mt-6 grid gap-x-10 gap-y-1 sm:grid-cols-2">
          {MATERIALS.map((m) => (
            <Link
              key={m.name}
              to={MATERIAL_LINK(m.name)}
              onClick={onPick}
              data-testid={`site-nav-material-${m.name.toLowerCase()}`}
              className="group border-b border-transparent py-3 transition-colors duration-200 hover:border-white/20"
            >
              <span className="s-display flex items-center gap-2 text-lg">
                {m.name}
                <ArrowRight
                  size={13}
                  weight="bold"
                  className="-translate-x-1 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100"
                />
              </span>
              <span className="mt-0.5 block text-xs text-white/50">
                {m.tag}
              </span>
            </Link>
          ))}
        </div>
      </div>

      <div>
        <div className="s-micro text-[color:var(--s-gold-bright)]">Quick picks</div>
        <div className="mt-6 flex flex-col gap-1">
          {QUICK_LINKS.map((q) => {
            const Icon = QUICK_ICONS[q.slug];
            return (
              <Link
                key={q.slug}
                to={q.to}
                onClick={onPick}
                data-testid={`site-nav-material-${q.slug}`}
                className="s-display flex items-center gap-2.5 py-2.5 text-lg text-white transition-opacity duration-200 hover:opacity-60"
              >
                {Icon && (
                  <Icon
                    size={15}
                    weight="bold"
                    className="text-[color:var(--s-gold)]"
                  />
                )}
                {q.label}
              </Link>
            );
          })}
        </div>
      </div>

      <Link
        to={REMNANT_LINK.to}
        onClick={onPick}
        data-testid="site-nav-material-remnants"
        className="group relative flex flex-col justify-between overflow-hidden border border-white/10 bg-white/[0.05] p-8 text-white transition-transform duration-500 hover:-translate-y-1"
      >
        <span
          aria-hidden
          className="absolute -right-16 -top-16 h-44 w-44 rounded-full bg-[color:var(--s-gold)]/25 blur-2xl transition-opacity duration-500 group-hover:opacity-70"
        />
        <span className="relative">
          <span className="s-micro text-[color:var(--s-gold)]">
            {VIEWS.remnant.micro}
          </span>
          <span className="s-display mt-4 block text-3xl">Remnants</span>
          <span className="mt-3 block text-sm leading-relaxed text-white/70">
            Vanities, hearths and tabletops from job offcuts — a fraction of a
            full slab.
          </span>
        </span>
        <span className="s-micro relative mt-8 flex items-center gap-2 text-[color:var(--s-gold)]">
          Browse remnants
          <ArrowRight
            size={13}
            weight="bold"
            className="transition-transform duration-300 group-hover:translate-x-1"
          />
        </span>
      </Link>
    </div>
  </div>
);

export default InventoryMega;
